// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { OrderProductOptionRequest } from './order-product-option-request';

/** See com.rev360.pms.api.controller.order.UpdateEyeglassLensOrderDetailRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateEyeglassLensOrderDetailRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Bifocal Size cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	bifocalSize!: string | null;

	@GandalfProperty({ designType: Number })
	locationProductId!: number | null;

	@GandalfProperty({ designType: Number })
	locationProductItemId!: number | null;

	@GandalfSubRequestLabel('PAL')
	@GandalfProperty({ designType: OrderProductOptionRequest })
	pal!: OrderProductOptionRequest | null;

	@GandalfValidator({ notNull: { message: 'Single Vision is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	singleVision!: boolean;

	@GandalfValidator({ sizeString: { message: 'Trifocal Size cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	trifocalSize!: string | null;

}
